import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faMessage } from "@fortawesome/pro-regular-svg-icons";
import { faBolt, faSpinner } from "@fortawesome/pro-solid-svg-icons";

import { CopywritingStatus } from "@/pages/Private/pages/Messages/components/GenerateBar/types";

import { ListPerson } from "../../../../../schema/list";
import { InfoTag } from "./InfoTag";

/**
 * Chat drafts for a lead outside a campaign: being generated, or ready to review in the chat.
 * Nothing for a lead with a campaign — the two are mutually exclusive. Extracted from `Lead.tsx`
 * so both lead cards show it (PREC-4175).
 */
export const ChatDraftsTag: FunctionComponent<{ row: ListPerson; onReviewChat?: () => void }> = ({
	row,
	onReviewChat,
}) => {
	const { t } = useTranslation();

	if (row.campaignId) {
		return null;
	}

	if (
		row.copywritingStatus === CopywritingStatus.QUEUED ||
		row.copywritingStatus === CopywritingStatus.RUNNING
	) {
		return (
			<div className="w-fit h-fit">
				<InfoTag icon={faSpinner} iconSpin label={t("messages.generatingDrafts")} style="action" />
			</div>
		);
	}

	if (row.copywritingEventId && row.copywritingStatus === CopywritingStatus.COMPLETED) {
		return (
			<div className="w-fit h-fit" onClick={() => onReviewChat?.()}>
				<InfoTag
					hoverIcon={faMessage}
					hoverLabel="Review in chat"
					icon={faBolt}
					label={t("messages.chatDraftsReady")}
					style="action"
				/>
			</div>
		);
	}

	return null;
};
